var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-modal',{attrs:{"title":"Pendientes recurrentes","hide-footer":"","size":"lg","id":"pendings-recurrentes"},on:{"show":_vm.on_show,"hide":_vm.on_hide}},[_c('list',{attrs:{"recurrentes":_vm.recurrentes,"loading":_vm.loading}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }